/* src/app/modules/expense/correos-ia/correos-ia.component.css */
.w-100 {
  width: 100%;
}
/*# sourceMappingURL=correos-ia.component.css.map */
